import { createContext } from 'react'

/**
 * Provides analytics callbacks for poll interactions (link clicks, dropdown opens).
 * PollStep3 is the provider; PollDropdownButton (rendered via inner Puck <Render>) is a consumer.
 */
const PollAnalyticsContext = createContext({
  onAnswerLinkClick: null,
  onAnswerDropdownClick: null,
})

export default PollAnalyticsContext
